'use client'

// Locale helpers for the nav. Reads the current locale from next-intl's
// provider, and provides a setter that writes the NEXT_LOCALE cookie and
// does a hard reload so the server re-reads the cookie and re-imports
// the right messages JSON. router.refresh() is flakier across Next 16 +
// next-intl 4 — reload is 10ms slower and 100% reliable.

import { useCallback } from 'react'
import { useLocale as useNextIntlLocale } from 'next-intl'

export type Locale = 'es' | 'en'

export function useLocale(): [Locale, (next: Locale) => void] {
  const raw = useNextIntlLocale()
  const locale: Locale = raw === 'en' ? 'en' : 'es'

  const setLocale = useCallback((next: Locale) => {
    if (next === locale) return
    // 1-year cookie; Path=/ so it covers every route.
    document.cookie = `NEXT_LOCALE=${next}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
    // Full reload — forces a fresh server render with the new cookie in
    // the request headers. Preserves scroll position in modern browsers.
    window.location.reload()
  }, [locale])

  return [locale, setLocale]
}
